<template>
  <div>
    <v-chip
      v-for="file in adminAppointmentFiles"
      :key="file.id"
      :href="file.url"
      color="grey lighten-3"
      class="files__item"
      target="_blank"
    >
      <v-tooltip top>
        <template v-slot:activator="{ on, attrs }">
          <div class="files__select">
            <input
              @change="pushFilesToDelete(file)"
              type="checkbox"
              :id="file.id"
            />
            <label :for="file.id" v-on="on" v-bind="attrs">
              <v-icon>mdi-check-bold</v-icon>
            </label>
          </div>
        </template>
        <span>{{ $t('upload.select') }}</span>
      </v-tooltip>

      <strong>{{ file.name }}</strong>

      <div class="files__actions">
        <v-tooltip top>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-on="on"
              v-bind="attrs"
              @click.prevent="deleteFile(file)"
              :disabled="isAppointmentFilesDeleting"
              color="red"
              class="ml-3"
              icon
            >
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('upload.exclude') }}</span>
        </v-tooltip>
      </div>
    </v-chip>

    <HUploading v-if="isAppointmentFilesUploading" class="mb-4" />

    <div class="d-block mh-5 mb-n1">
      <v-progress-linear
        v-if="isAppointmentFilesLoading"
        color="primary"
        indeterminate
        absolute
      />
    </div>

    <HUpload
      @change="handleGetFiles"
      componentId="uploadFiles"
      multiple
    />

    <ModalAppointmentDeleteOneFile
      :handleDelete="deleteAppointmentFileAsAdmin"
      @resetSelectedFiles="setAdminAppointmentFilesToDelete([])"
      modalName="DELETE_ONE_APPOINTMENT_FILE"
    />
    <ModalAdminAppointmentDeleteAllFiles />
    <ModalAppointmentDeleteSelectedFiles
      :handleDelete="deleteAppointmentFileAsAdmin"
      :files="adminAppointmentFilesToDelete"
      modalName="DELETE_SELECTED_APPOINTMENT_FILES"
    />
  </div>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'

import HUpload from '../lib/HUpload'
import HUploading from '@/components/app/HUploading'

import ModalAppointmentDeleteOneFile from './modals/ModalAppointmentDeleteOneFile'
import ModalAdminAppointmentDeleteAllFiles from './modals/admin/file/ModalAdminAppointmentDeleteAllFiles'
import ModalAppointmentDeleteSelectedFiles from './modals/admin/ModalAppointmentDeleteSelectedFiles'

export default {
  name: 'AdminAppointmentFilesUpload',

  components: {
    HUpload,
    HUploading,
    ModalAppointmentDeleteOneFile,
    ModalAdminAppointmentDeleteAllFiles,
    ModalAppointmentDeleteSelectedFiles,
  },

  data() {
    return {
      files: [],
      file: null,
    }
  },

  computed: {
    ...mapGetters([
      'adminAppointmentFiles',
      'isAppointmentFilesLoading',
      'isAppointmentFilesUploading',
      'adminAppointmentFilesToDelete',
      'isAppointmentFilesDeleting',
    ]),
  },

  methods: {
    ...mapActions([
      'openModal',
      'attachAppointmentFilesAsAdmin',
      'deleteAppointmentFileAsAdmin'
    ]),

    ...mapMutations(['closeAllModals', 'setAdminAppointmentFilesToDelete']),

    handleGetFiles(files) {
      this.attachAppointmentFilesAsAdmin(files)
    },

    expandFile(url) {
      this.file = url
      this.openModal('APPOINTMENT_FILE_VISUALIZATION')
    },

    deleteFile(file) {
      this.setAdminAppointmentFilesToDelete([])

      Promise.resolve(this.setAdminAppointmentFilesToDelete([file])).then(() => {
        this.openModal('DELETE_ONE_APPOINTMENT_FILE')
      })
    },

    pushFilesToDelete(id) {
      const files = this.adminAppointmentFilesToDelete
      const index = files.indexOf(id)

      if (index >= 0) {
        files.splice(index, 1)
        this.setAdminAppointmentFilesToDelete(files)
      } else {
        files.push(id)
        this.setAdminAppointmentFilesToDelete(files)
      }
    },
  },
}
</script>
